import React, { useRef, useEffect, useState } from 'react';
import { loadModules } from 'esri-loader';
import { useSelector, useDispatch } from "react-redux";
import { updateSelection } from "../../../redux/actions/facilityActions";

export default function ResultsMap(props) {
  const SITE_URI = process.env.REACT_APP_B2C_POST_LOGOUT_URI;
  const search = useSelector(state => state.search);
  const currentSelection = useSelector(state => state.currentSelection);
  const mapRef = useRef(null);
  const dispatch = useDispatch();
  const [map, setMap] = useState();
  const [view, setView] = useState();
  const [facilityLayer, setFacilityLayer] = useState();

  const defaultSymbol = {
    type: "simple-marker",
    size: 8,
    color: [255, 0, 0],
  };
  const facilityRenderer = {
    type: "simple",
    symbol: defaultSymbol
  };

  useEffect(() => {
    createMap();
  }, [])

  useEffect(() => {
    if (map) createView();
  }, [map])

  useEffect(() => {
    if (search.searchResults.length > 0) createMarkers();
  }, [view, search.searchResults])

  useEffect(() => {
    if (map && facilityLayer) {
      map.removeAll();
      map.add(facilityLayer);
    }
  }, [facilityLayer])

  useEffect(() => {
    if (view) {
      view.on("click", (e) => {
        view.hitTest(e).then((event) => {
          if (event.results.length > 0) {
            let facility = search.searchResults.find(
              (fac) => fac.EPA_ID === event.results[0].graphic.attributes.EPA_ID);
            view.popup.triggerAction(
              onMouseOverMarker(event.screenPoint, facility)
            );
          } else {
            //map.layers.items[0].renderer = facilityRenderer;
          }
        })
      });
    }
  }, [search])

  function queryLayer(point) {
    var query = facilityLayer.createQuery();
    query.geometry = point;
    query.spatialRelationship = "intersects";
    return facilityLayer.queryFeatures(query);
  }

  function showPopup(res) {
    view.popup.open({
      features: res.features,
      updateLocationEnabled: true
    });
  }

  useEffect(() => {
    if (view && currentSelection.facLat !== null && currentSelection.facLng !== null) {
      loadModules(["esri/geometry/Point"], { css: true }).then(([Point]) => {
        var point = new Point({ latitude: currentSelection.facLat, longitude: currentSelection.facLng });
        queryLayer(point).then(showPopup);
        view.goTo({
          target: point,
          //zoom: 10,
        })
      })
    }
  }, [currentSelection])

  async function createMap() {
    await loadModules(["esri/WebMap"], { css: true }).then(([WebMap]) => {
      let m = new WebMap({
        basemap: "streets-navigation-vector",
        center: [-122.057281, 38.250313],
        zoom: 8,
      });

      setMap(m);
    });
  }

  async function createView() {
    await loadModules(["esri/views/MapView", "esri/widgets/ScaleBar", "esri/renderers/UniqueValueRenderer"], { css: true }).then(([MapView, ScaleBar, UniqueValueRenderer]) => {
      let view = new MapView({
        container: mapRef.current,
        map: map,
        center: [-122.057281, 38.250313],
        zoom: 8,
        highlightOptions: {
          fillOpacity: 0,
          color: [50, 50, 50],
        },
        popup: {
          collapseEnabled: false,
        },
        constraints: {
          maxScale: 35000,
          minScale: 10000000,
        },
      });

      var scaleBar = new ScaleBar({
        view: view,
      });
      view.ui.add(scaleBar, "bottom-right");

      setView(view);
    });
  }

  async function createMarkers() {
    await loadModules(["esri/layers/FeatureLayer", "esri/layers/support/Field"]).then(([FeatureLayer, Field]) => {

      const fields = [
        new Field({
          name: "ObjectID",
          alias: "ObjectID",
          type: "oid",
        }),
        new Field({
          name: "facName",
          alias: "FacName",
          type: "string",
        }),
        new Field({
          name: "EPA_ID",
          alias: "EPA_ID",
          type: "string",
        }),
        new Field({
          name: "facStreet1",
          alias: "FacStreet1",
          type: "string",
        }),
        new Field({
          name: "facCity",
          alias: "FacCity",
          type: "string",
        }),
        new Field({
          name: "facZip",
          alias: "FacZip",
          type: "string",
        }),
        new Field({
          name: "facSt",
          alias: "FacSt",
          type: "string",
        }),
        new Field({
          name: "facLat",
          alias: "FacLat",
          type: "double",
        }),
        new Field({
          name: "facLng",
          alias: "FacLng",
          type: "double",
        }),
      ];

      const results = search.searchResults.filter((item) => {
        return item.Fac_Longitude <= -113 && item.Fac_Latitude >= -125;
      });

      const facilities = results.map((data, idx) => {
        return {
          geometry: {
            type: "point",
            x: data.Fac_Longitude,
            y: data.Fac_Latitude,
          },
          attributes: {
            ObjectID: idx,
            FacName: data.Facility_Name,
            EPA_ID: data.EPA_ID,
            FacStreet1: data.Street,
            FacCity: data.City,
            FacZip: data.Zip_Code,
            FacSt: data.State,
            FacLat: data.Fac_Latitude,
            FacLng: data.Fac_Longitude,
          },
        };
      });

      var facilitiesPopup = {
        title: `<a href='${SITE_URI}/facility/{EPA_ID}' target='_'><b>{facName}</b></a>`,
        content:
          "{EPA_ID}<br><p style='display:-webkit-inline-box'>{facStreet1}<br>{facCity}, {facSt} {facZip}<br>({facLat}, {facLng})</p>",
      };

      const fl = new FeatureLayer({
        title: "facility layer",
        source: facilities,
        fields: fields,
        ObjectIDField: "ObjectID",
        renderer: facilityRenderer,
        popupTemplate: facilitiesPopup,
        outFields: ['*']
      });

      fl.on("layerview-create", (e) => {
        fl.queryExtent().then((response) => {
          if (response.count === 1) {
            view.goTo({
              target: facilities[0],
              zoom: 20,
            });
          } else {
            view.goTo(response.extent.expand(1.1));
          }
        });
      });

      setFacilityLayer(fl);
    })
      .catch((err) => console.error(err));
  }

  const onMouseOverMarker = (position, facility) => {
    dispatch(updateSelection(
      facility.EPA_ID,
      facility.Facility_Name,
      facility.Street,
      facility.City,
      facility.County,
      facility.Zip_Code,
      facility.Fac_Latitude,
      facility.Fac_Longitude,
      true,
      "resultsMap"
    ));
  };

  return (
    <div>
      <div>
        <div id="mapDiv" className="webmap-resultsmap" ref={mapRef} />
      </div>
    </div>
  );
}